import { Col, Row, Button, Container, Accordion, Image, Table, Tabs, Tab, Navbar, Nav } from "react-bootstrap";
import "../index.css";
import { Helmet } from "react-helmet";
import FAQ_EN from "./FAQ_EN";
import FAQ_NL from "./FAQ_NL";
import { useState } from "react";
export default function FAQ() {

    const [selectedLanguage, setSelectedLanguage] = useState<"EN" | "NL">("EN");

    return (
        <>
            <Helmet>
                <title>{"EarsOnly | FAQ"}</title>
            </Helmet>
            <Row className="flag-selection">
                <Col
                    style={selectedLanguage === "NL" ? { border: "2px solid black" } : { border: "2px solid white" }}
                    className="flag" onClick={() => setSelectedLanguage("NL")}>
                    &#x1F1F3;&#x1F1F1;
                </Col>
                <Col className="flag"
                    style={selectedLanguage === "EN" ? { border: "2px solid black" } : { border: "2px solid white" }}
                    onClick={() => setSelectedLanguage("EN")}>
                    &#127468;&#127463;
                </Col>
            </Row>
            {selectedLanguage === "NL" &&
                <FAQ_NL />
            }
            {selectedLanguage === "EN" &&
                <FAQ_EN />
            }

        </>
    );
}
